export default __webpack_public_path__ + "static/media/UpsWarningBackground.e1b1d742.png";